import classnames from "classnames";
import { noop } from "neetocist";
import { joinHyphenCase } from "neetocommons/utils/general";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";

const Block = ({
  url,
  icon,
  label,
  count,
  active = false,
  onEdit,
  onClick = noop,
  className,
  ...otherProps
}) => {
  const handleEdit = e => {
    if (!onEdit) return;

    e.stopPropagation();
    onEdit();
  };

  const Parent = url ? Link : props => <button type="button" {...props} />;

  return (
    <Parent
      data-testid={otherProps["data-testid"] || "menubar-block"}
      to={url}
      className={classnames(
        "hover:bg-accent focus:bg-accent active:bg-accent relative mb-2 flex w-full cursor-pointer items-center justify-between rounded-md border border-transparent px-2 py-1.5 text-start transition-all hover:no-underline focus:outline-none motion-reduce:transition-none",
        {
          "bg-primary/10 border-primary/10 after:bg-primary hover:bg-primary/10 focus:bg-primary/10 active:bg-primary/10 after:absolute after:inset-y-0 after:start-[-1px] after:w-[3px] after:rounded-s-md":
            active,
          [className]: className,
        }
      )}
      {...{ onClick, ...otherProps }}
    >
      <div
        className="flex items-center"
        data-testid={joinHyphenCase("menubar-block-label", label)}
      >
        {icon && <i className="me-1 flex items-center">{icon}</i>}
        <span className="text-sm font-medium" title={label}>
          {label}
        </span>
      </div>
      {Number.isInteger(count) && (
        <div onClick={handleEdit}>
          <span className="text-sm font-medium">{count}</span>
        </div>
      )}
    </Parent>
  );
};

Block.propTypes = {
  url: PropTypes.string,
  icon: PropTypes.node,
  label: PropTypes.string,
  count: PropTypes.number,
  active: PropTypes.bool,
  onEdit: PropTypes.func,
  onClick: PropTypes.func,
  className: PropTypes.string,
};

export default Block;
